module.exports = __webpack_public_path__ + "img/negative-end-screen.84d53247.svg";